

























































import Vue from "vue";
import { mapSyncComputed } from "../plugins/SyncComputedHelper";
import { mapActions } from "vuex";

export default Vue.extend({
	props: {
		value: Object,
	},
	data() {
		return {
			email: null,
			password: null,
			password2: null,
			userName: null,
		};
	},
	computed: {
		...mapSyncComputed(),
	},
	methods: {
		...mapActions(["register"]),
		tryRegister() {
			if (this.email && this.password === this.password2) {
				this.register({
					email: this.email,
					_password: this.password,
					UserFIO: this.userName,
					useAuthProvider: true,
				});
			}
		},
	},
});
